import React, { useContext, useEffect, useRef, useState } from "react";

import { useLocation } from "react-router-dom";
import { downloadElementAsPdf } from "../../../utils/downloadPdf";
import { MyContext } from "../../../context/MyContext";

import { backIncstance, checkGroupId } from "../../../utils/commonFunctions";
import CustomChart from "../../../components/CustomChart";
import Loading from "../../../components/Loading";

import Reload from "../../../assets/icons/icon_reload.png";
import Download from "../../../assets/icons/icon_download.png";

const URLS = {
  GET_GROUP_RESULT: process.env.REACT_APP_SOCRATES_GET_GROUP_RESULT,
  GET_STORAGE_RESULT: process.env.REACT_APP_SOCRATES_GET_STORAGE_RESULT,
};
const COLORS = {
  우수: {
    borderColor: "#528DFF",
    backgroundColor: "#F6F7FF",
  },
  보통: {
    borderColor: "#21C781",
    backgroundColor: "#F2FFF9",
  },
  노력: {
    borderColor: "#F39F21",
    backgroundColor: "#FFFAED",
  },
};

// react-html2pdf 의 Preview 를 대체한다.
// 기존 Preview 는 className/scale prop 을 사용하지 않았고 데스크톱에서는
// 숨겨진 복제본(210mm)에만 id 를 붙였다. 화면 출력이 달라지지 않도록
// className 적용 여부는 기존 동작(모바일에서만 적용)을 그대로 유지하고,
// PDF 캡쳐 대상 id 는 실제 표시되는 엘리먼트에 부여한다.
const PdfWrapper = ({ isMobile, id, className, children }) => (
  <div id={id} className={isMobile ? className : undefined}>
    {children}
  </div>
);

const Result = (props) => {
  const { paramId, list, isMobile, setAlertSetting } = useContext(MyContext);

  const location = useLocation();
  const [result, setResult] = useState({
    user_name: null,
    apply_org: null,
    inter_area: null,
    tt_latency: 0,
    tt_ques_cnt: 0,
    tt_ans_cnt: 0,
    avg_latency: 0,
    avg_words: 0,
    top_word_list: [],
    fluency_sc: 0,
    fluency_eva: null,
    fluency_reason: null,
    logic_sc: 0,
    logic_eva: null,
    logic_reason: null,
    ps_sc: 0,
    ps_eva: null,
    ps_reason: null,
    accuracy_sc: 0,
    accuracy_eva: null,
    accuracy_reason: null,
    commu_sc: 0,
    commu_eva: null,
    commu_reason: null,
    created_at: null,
  });
  const today = new Date(result?.created_at);
  const [arrData, setArrData] = useState([
    {
      target: null,
      score: null,
      evaluation: null,
      reason: null,
    },
  ]);

  const radarStyle = {
    width: "200px",
    height: "200px",
  };
  const config = {
    type: "radar",
    data: arrData,
    options: {
      elements: {
        line: {
          borderWidth: 3,
        },
      },
      scales: {
        r: {
          // Radar 차트의 축 설정
          suggestedMin: 0,
          suggestedMax: 10,
        },
        ticks: {
          beginAtZero: true,
          max: 10,
          min: 0,
          stepSize: 1,
        },
        yAxes: [
          {
            stacked: true,
            lineWidth: 0,
            drawBorder: false,
          },
        ],
        xAxes: [
          {
            stacked: true,
            lineWidth: 0,
            drawBorder: false,
          },
        ],
        borderColor: "#ffffff",
      },
    },
  };

  const [chartData, setChartData] = useState([]);

  const transformResultToData = (arrData) => {
    return arrData.map((item) => ({
      subject: item.target,
      score: item.score,
      fullMark: 10,
    }));
  };

  useEffect(() => {
    if (arrData[0].target !== null) {
      const transformedData = transformResultToData(arrData);
      setChartData(transformedData);
    }
  }, [arrData]);

  const [loading, setIsLoading] = useState(false);

  const touchAPI = async (method, url, data) => {
    setIsLoading(true);
    try {
      let targetUrl = url;
      if (
        location?.state?.from_chat === "group" &&
        url === URLS.GET_STORAGE_RESULT
      ) {
        targetUrl = URLS.GET_GROUP_RESULT;
      } else if (
        location?.state?.from_chat === "storage" &&
        url === URLS.GET_GROUP_RESULT
      ) {
        targetUrl = URLS.GET_STORAGE_RESULT;
      }
      const response = await backIncstance(method, targetUrl, data);
      const resData = await response.json();

      if (targetUrl === URLS.GET_GROUP_RESULT) {
        if (resData.detail) {
        } else if (!resData.detail) {
          setResult(resData);
          let newArr = [];
          let target = {};

          for (let key in resData) {
            const keyName = key.includes("fluency")
              ? "fluency"
              : key.includes("ps")
              ? "ps"
              : key.includes("commu")
              ? "commu"
              : key.includes("accuracy")
              ? "accuracy"
              : key.includes("logic")
              ? "logic"
              : null;
            const korean = key.includes("fluency")
              ? "유창성"
              : key.includes("ps")
              ? "문제해결"
              : key.includes("commu")
              ? "의사소통"
              : key.includes("accuracy")
              ? "정확성"
              : key.includes("logic")
              ? "논리성"
              : null;
            if (!keyName || target[keyName]) continue;
            let obj = {
              target: korean,
              score: resData[`${keyName}_sc`],
              evaluation: resData[`${keyName}_eva`],
              reason: resData[`${keyName}_reason`],
            };
            newArr.push(obj);
            target[keyName] = true;
          }
          let uniqueArr = newArr.filter((item, index) => {
            return newArr.indexOf(item) === index;
          });
          if (uniqueArr.length !== 0) {
            setArrData(uniqueArr);
          }
        } else {
        }
      } else {
        if (resData.detail) {
        } else if (!resData.detail) {
          setResult(resData);
          let newArr = [];
          let target = {};

          for (let key in resData) {
            const keyName = key.includes("fluency")
              ? "fluency"
              : key.includes("ps")
              ? "ps"
              : key.includes("commu")
              ? "commu"
              : key.includes("accuracy")
              ? "accuracy"
              : key.includes("logic")
              ? "logic"
              : null;
            const korean = key.includes("fluency")
              ? "유창성"
              : key.includes("ps")
              ? "문제해결"
              : key.includes("commu")
              ? "의사소통"
              : key.includes("accuracy")
              ? "정확성"
              : key.includes("logic")
              ? "논리성"
              : null;
            // if (key.includes('fluency {
            if (!keyName || target[keyName]) continue;
            let obj = {
              target: korean,
              score: resData[`${keyName}_sc`],
              evaluation: resData[`${keyName}_eva`],
              reason: resData[`${keyName}_reason`],
            };
            newArr.push(obj);
            target[keyName] = true;
          }
          let uniqueArr = newArr.filter((item, index) => {
            return newArr.indexOf(item) === index;
          });
          if (uniqueArr.length !== 0) {
            setArrData(uniqueArr);
          }
        } else {
        }
      }
    } catch (err) {
      console.error("Error");
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: "닫기",
      }));
    } finally {
      setIsLoading(false);
    }
  };

  const getResult = (data) => {
    if (!data) return;

    const pathSegments = location.pathname.split("/");
    const target = data?.state?.from_chat;
    const parmas = Number(pathSegments[2]);
    touchAPI(
      "GET",
      target === "storage" ? URLS.GET_STORAGE_RESULT : URLS.GET_GROUP_RESULT,
      `/${parmas}`
    );
  };

  const [interviewInfo, setInterviewInfo] = useState({
    created_at: "",
    from_chat: "",
    id: 0,
    isClicked: false,
    isEdit: false,
    is_completed: true,
    is_exp: false,
    is_writed: true,
    title: "",
    updated_at: "",
  });

  useEffect(() => {
    const currentItem = list?.find((item) => item.id === Number(paramId));
    if (currentItem?.id) {
      setInterviewInfo(currentItem);
    }
  }, [paramId]);
  useEffect(() => {
    getResult(location);
  }, [location]);

  const contentRef = useRef(null);

  const convertToPdf = () => {
    const title = interviewInfo.title ? interviewInfo.title : "소크라테스";
    return downloadElementAsPdf("pdf-result", `${title} 면접 결과`);
  };

  useEffect(() => {
    window.addEventListener("keydown", function (event) {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === "+" || event.key === "-" || event.key === "0")
      ) {
        event.preventDefault();
      }
    });

    window.addEventListener(
      "wheel",
      function (event) {
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  }, []);
  return (
    <main
      className="ctn-wrp result-wrp"
      ref={contentRef}
      style={{
        margin: "auto",
      }}
    >
      <div className="inner">
        <div className="top flx-box sep-elm">
          {/* {!loading && result.user_name !== null && ( */}
          {!loading && (
            <>
              <h1>{interviewInfo.title}</h1>
              {!isMobile && (
                <button className="pdf-download crs-btn" onClick={convertToPdf}>
                  <img src={Download} alt="" />
                  PDF 다운로드
                </button>
              )}
            </>
          )}
        </div>

        {loading ? (
          <Loading />
        ) : // (!loading && result.user_name !== null)
        !loading ? (
          <PdfWrapper
            isMobile={isMobile}
            scale={1}
            id="pdf-result"
            className="my-result"
          >
            <div className="result-top">
              <div className="flx-box">
                <h1 className="result_header">기본정보</h1>
              </div>
              <div className="result-top__wrp">
                <div className="flx-box">
                  <div className="result-top__title">검사일시</div>
                  <div className="result-top__desc">{`${today.getFullYear()}년 ${
                    today.getMonth() + 1
                  }월 ${today.getDate()}일 ${today.getHours()}시 ${today.getMinutes()}분`}</div>
                  <div className="result-top__title">성명</div>
                  <div className="result-top__desc">{result.user_name}</div>
                </div>
                <div className="flx-box">
                  <div className="result-top__title">면접유형</div>
                  <div className="result-top__desc">{result.form_kind}</div>
                  <div className="result-top__title">지원기관</div>
                  <div className="result-top__desc">{result.apply_org}</div>
                </div>
                <div className="flx-box">
                  <div className="result-top__title">관심영역</div>
                  <div className="result-top__desc">{result.inter_area}</div>
                  <div className="result-top__title">업로드파일</div>
                  <div className="result-top__desc"></div>
                </div>
              </div>
            </div>
            <div className="result-middle">
              <h1 className="result_header">결과 요약</h1>
              <div className="result-middle__wrp flx-box ">
                <div className="left">
                  <p className="summary__title">면접 총 응시시간</p>
                  <div className="summary__desc">
                    <div className="diagram">
                      <div className="parah">
                        <p className="bolx-txt">
                          {`${Math.floor(result.tt_latency / 60)}`}
                          <span>분</span>
                        </p>
                        <p className="mild-txt">
                          {(() => {
                            let seconds = result.tt_latency % 60;
                            let roundedSeconds = Math.round(seconds).toString();
                            let formattedSeconds =
                              roundedSeconds.length > 2
                                ? roundedSeconds.slice(0, 2)
                                : roundedSeconds.padStart(2, "0");
                            return `${formattedSeconds}`;
                          })()}
                          <span>초</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="middle">
                  <div className="small-rate">
                    <p className="summary__title">문항별 평균 글자 수</p>
                    <div className="summary__desc">
                      <div className="parah">{`${result.avg_words} 개`}</div>
                    </div>
                  </div>

                  <div className="small-rate">
                    <p className="summary__title">문항별 평균 답변 시간</p>
                    <div className="summary__desc">
                      <div className="background">
                        <div
                          className="progress-rate"
                          style={{
                            width: `${(result.avg_latency / 120) * 100}%`,
                            height: "100%",
                            transition: "all ease 1.2s",
                            borderRadius: "2rem",
                          }}
                        />
                      </div>
                      <div className="parah">{`${Math.floor(
                        result.avg_latency / 60
                      )}분 ${result.avg_latency % 60}초`}</div>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <div>
                    <p className="summary__title">문항 개수 / 답변 개수</p>
                    <div className="summary__desc">
                      <div className="diagram">
                        {typeof result.tt_ans_cnt === "number" &&
                          Array.from(
                            { length: result.tt_ans_cnt },
                            (_, fillIdx) => {
                              return fillIdx % 2 === 0 ? (
                                <div
                                  key={`empty-${fillIdx}`}
                                  className="my-ans"
                                ></div>
                              ) : null;
                            }
                          )}
                        {typeof result.tt_ques_cnt === "number" &&
                          Array.from(
                            { length: result.tt_ques_cnt - result.tt_ans_cnt },
                            (_, restIdx) => {
                              return restIdx % 2 === 0 ? (
                                <div
                                  key={`empty-${restIdx}`}
                                  className="empty-ans"
                                ></div>
                              ) : null;
                            }
                          )}
                      </div>
                      <div className="parah">{`${result.tt_ans_cnt}/${result.tt_ques_cnt}개`}</div>
                    </div>
                  </div>
                  <div className="small-rate">
                    <p className="summary__title">자주 사용한 단어 상위 3개</p>
                    <div className="fav-list flx-box">
                      {Array.isArray(result.top_word_list) &&
                        result?.top_word_list?.map((wordItem, wordIdx) => {
                          return (
                            <p
                              className="summary__desc fav-word"
                              key={wordItem}
                            >
                              {wordItem}
                            </p>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="result-bottom__wrp">
              <h1 className="result_header">종합결과</h1>
              <div className="">
                <div className="diagram">
                  <CustomChart
                    options={config}
                    data={chartData}
                    type="radar"
                    style={radarStyle}
                  />
                </div>
                <ul className="chart">
                  {arrData.map((resultItem, resultIdx) => {
                    if (!resultItem.score) {
                      return null;
                    }
                    return (
                      <li key={resultItem.target} className="flx-box flex-col">
                        <div className="flx-box w-auto">
                          <p className="chart__title">{resultItem.target}</p>
                          <div
                            className="chart__score w-fit"
                            style={{
                              border: `1px solid ${
                                COLORS[resultItem.evaluation]?.borderColor
                              }`,
                              color: COLORS[resultItem.evaluation]?.borderColor,
                              backgroundColor:
                                COLORS[resultItem.evaluation]?.backgroundColor,
                            }}
                          >
                            {resultItem.evaluation}
                          </div>
                        </div>
                        <p className="chart__desc">{resultItem.reason}</p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </PdfWrapper>
        ) : (
          <div className="no-result">
            <p>생성된 결과가 없습니다. 잠시후 다시 시도해주세요.</p>
            <img
              className="crs-btn"
              src={Reload}
              alt="icon-reload-page"
              onClick={getResult}
            />
          </div>
        )}
      </div>
    </main>
  );
};

export default Result;
